/*jshint browserify: true */
'use strict';

module.exports = DialogService;

DialogService.$inject = ['$window'];

/**
 * For displaying a dialog. Dialog is a "floating" HTML element within the same window.
 */
function DialogService($window) {
    var service = {
        showDialog: showDialog
    };

    return service;

    /**
     * @param {String} templateHtml
     * @param {Scope} scope - The scope to attach to the dialog.
     */
    function showDialog(templateHtml, scope) {
        $window.alert('Want to show a dialog');
    }
}